import React from 'react';

function MatchDetailsForm({
  isMatchDetailsExpanded,
  setIsMatchDetailsExpanded,
  data,
  setData,
  onField,
  onOpponentChange,
  generateShareToken,
  showNotice,
  tournaments,
  FEATURES
}) {
  return (
    <section style={{ 
      background: "#fff", 
      border: "1px solid var(--border)", 
      borderRadius: "12px", 
      padding: "24px", 
      marginBottom: "24px" 
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: isMatchDetailsExpanded ? "20px" : "0",
        cursor: "pointer"
      }}
      onClick={() => setIsMatchDetailsExpanded(!isMatchDetailsExpanded)}
      >
        <h2 style={{ 
          fontSize: "20px", 
          fontWeight: "600", 
          margin: "0", 
          color: "var(--text)" 
        }}>
          Match Details
        </h2>
        <button
          type="button"
          style={{
            background: "transparent",
            border: "none",
            color: "var(--muted)",
            cursor: "pointer",
            fontSize: "16px",
            padding: "4px",
            borderRadius: "4px",
            transition: "all 0.2s ease",
            transform: isMatchDetailsExpanded ? "rotate(180deg)" : "rotate(0deg)"
          }}
          title={isMatchDetailsExpanded ? "Collapse" : "Expand"}
        >
          ▼
        </button>
      </div>
      
      {isMatchDetailsExpanded && (
        <>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "16px",
            marginBottom: "20px"
          }}>
            <div>
              <label style={{
                display: "block",
                fontSize: "12px",
                fontWeight: "500",
                color: "var(--text)",
                marginBottom: "6px"
              }}>
                Match Date
              </label>
              <input
                type="date"
                className="input"
                value={data.matchDate}
                onChange={(e) => onField("matchDate")(e.target.value)}
                style={{ width: "100%" }}
              />
            </div>

            <div>
              <label style={{
                display: "block",
                fontSize: "12px",
                fontWeight: "500",
                color: "var(--text)",
                marginBottom: "6px"
              }}>
                Opponent
              </label>
              <input
                type="text"
                className="input"
                value={data.opponent}
                onChange={onOpponentChange}
                placeholder="e.g., Chelsea Bulldogs"
                style={{ width: "100%" }}
              />
            </div>

            {FEATURES.TOURNAMENTS && (
              <div>
                <label style={{
                  display: "block",
                  fontSize: "12px",
                  fontWeight: "500",
                  color: "var(--text)",
                  marginBottom: "6px"
                }}>
                  Tournament (Optional)
                </label>
                <select
                  className="input"
                  value={data.tournamentId || ""}
                  onChange={(e) => setData((d) => ({ ...d, tournamentId: e.target.value || null }))}
                  style={{ width: "100%" }}
                >
                  <option value="">No Tournament</option>
                  {tournaments.map((t) => (
                    <option key={t.id} value={t.id}>
                      {t.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {/* Make Public Toggle - Moved to separate row */}
          <div>
              <div style={{ 
                display: "flex", 
                alignItems: "center", 
                gap: "12px",
                fontSize: "14px", 
                fontWeight: "500", 
                color: "var(--text)", 
                marginBottom: "6px",
                cursor: "pointer"
              }}
              onClick={() => {
                const newIsPublic = !data.isPublic;
                setData(prev => ({
                  ...prev,
                  isPublic: newIsPublic,
                  shareToken: newIsPublic ? (prev.shareToken || generateShareToken()) : null
                }));
              }}
              >
                <div style={{
                  position: "relative",
                  width: "44px",
                  height: "24px",
                  backgroundColor: data.isPublic ? "var(--primary)" : "#ccc",
                  borderRadius: "12px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  flexShrink: 0
                }}>
                  <div style={{
                    position: "absolute",
                    top: "2px",
                    left: data.isPublic ? "22px" : "2px",
                    width: "20px",
                    height: "20px",
                    backgroundColor: "white",
                    borderRadius: "50%",
                    transition: "all 0.3s ease",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)"
                  }} />
                </div>
                <span>Make this match public (shareable)</span>
              </div>
              {data.isPublic && data.shareToken && (
                <div style={{
                  marginTop: "12px",
                  padding: "12px 16px",
                  background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
                  border: "1px solid #0ea5e9",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                }}>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      fontSize: "12px",
                      color: "var(--muted)",
                      marginBottom: "4px",
                      fontWeight: "500"
                    }}>
                      Share Link:
                    </div>
                    <div style={{
                      fontSize: "13px",
                      color: "var(--text)",
                      fontFamily: "monospace",
                      wordBreak: "break-all"
                    }}>
                      {window.location.origin}/match/{data.shareToken}
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      const shareUrl = `${window.location.origin}/match/${data.shareToken}`;
                      
                      // GA: Track share link copy
                      if (window.gtag) {
                        window.gtag("event", "share_link_copied", {
                          event_category: "Match Sharing",
                          event_label: data.playerName || 'Unknown Player',
                          custom_parameters: {
                            match_share_token: data.shareToken,
                            player_name: data.playerName || 'Unknown Player',
                            opponent: data.opponent || 'Unknown Opponent',
                            match_date: data.matchDate || 'Unknown Date'
                          }
                        });
                      }
                      
                      // Try modern clipboard API first, fallback to older method
                      if (navigator.clipboard && navigator.clipboard.writeText) {
                        navigator.clipboard.writeText(shareUrl).then(() => {
                          showNotice("success", "Share link copied to clipboard!");
                        }).catch(() => {
                          // Fallback for older browsers
                          const textArea = document.createElement('textarea');
                          textArea.value = shareUrl;
                          textArea.style.position = 'fixed';
                          textArea.style.left = '-999999px';
                          document.body.appendChild(textArea);
                          textArea.focus();
                          textArea.select();
                          try {
                            document.execCommand('copy');
                            showNotice("success", "Share link copied to clipboard!");
                          } catch (err) {
                            showNotice("error", "Failed to copy. Please copy manually: " + shareUrl);
                          }
                          document.body.removeChild(textArea);
                        });
                      } else {
                        // Fallback for browsers that don't support clipboard API
                        const textArea = document.createElement('textarea');
                        textArea.value = shareUrl;
                        textArea.style.position = 'fixed';
                        textArea.style.left = '-999999px';
                        document.body.appendChild(textArea);
                        textArea.focus();
                        textArea.select();
                        try {
                          document.execCommand('copy');
                          showNotice("success", "Share link copied to clipboard!");
                        } catch (err) {
                          showNotice("error", "Failed to copy. Please copy manually: " + shareUrl);
                        }
                        document.body.removeChild(textArea);
                      }
                    }}
                    style={{
                      background: "#0ea5e9",
                      color: "white",
                      border: "none",
                      borderRadius: "6px",
                      padding: "8px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "all 0.2s ease",
                      minWidth: "36px",
                      height: "36px"
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "#0284c7";
                      e.target.style.transform = "scale(1.05)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "#0ea5e9";
                      e.target.style.transform = "scale(1)";
                    }}
                    title="Copy share link"
                  >
                    📋
                  </button>
                </div>
              )}
            </div>
        </>
      )}
    </section>
  );
}

export default MatchDetailsForm;